const ErrorTableState = () => {
  return (
    <div className="flex h-56 items-center justify-center px-5 text-center">
      <div className="text-primary text-lg font-medium">Something went wrong</div>
    </div>
  );
};

export default ErrorTableState;
